var _getLogin$cnnc_getPcL;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 商城应用接口
 */
export default (_getLogin$cnnc_getPcL = {
  // 登录
  getLogin: {
    // mock: true,
    control: 'umc/users/signup/login'
  },
  // 手机验证码登录获取验证码
  cnnc_getPcLoginMobileVfCode: {
    // mock: true,
    control: 'umc/users/signup/getPcLoginMobileVfCode'
  },
  // 手机验证登录
  cnnc_mobile: {
    // mock: true,
    control: 'umc/users/signup/login/pc/mobile'
  },
  // 商品搜索
  m_Search: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/searchGoods'
  },
  // 商品搜索
  m_searchGoodProperty: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/searchGoodProperty'
  },
  // 热门搜索列表查询
  m_qryHotSearchList: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/qryHotSearchList'
  },
  // 查询首页展示订单数据
  fsc_createCompareOrder: {
    // mock: true,
    control: 'dyc/mall/user/noauth/statisticsQuery'
  },
  // 会员收货地址维护
  m_operLogisticsRela: {
    // mock: true,
    control: 'dyc/saas/common/user/queryDefaultAddress'
  },
  // 查询首页轮播图
  cms_Lunbotu: {
    // mock: true,
    control: 'upload/cms/column/lunbotu/index.html'
  },
  // 查询店铺首页推荐
  cms_shopRecommend: {
    // mock: true,
    control: 'upload/cms/column/recommend_shop/index.html'
  },
  // 查询首页品牌馆
  cms_brandRecommend: {
    // mock: true,
    control: 'upload/cms/column/brandRecommend/index.html'
  },
  // 查询店铺首页轮播图
  cms_shopLunbo: {
    // mock: true,
    control: 'upload/cms/column/shop_lunbo/index.html'
  },
  // 查询店铺首页广告位
  cms_shopA: {
    // mock: true,
    control: 'upload/cms/column/shop_a/index.html'
  },
  // 查询顶部通知
  cms_homeNotify: {
    // mock: true,
    control: 'upload/cms/column/homeNotify/index.html'
  },
  // 首页U谷优商
  cms_shoppingExcellentShop: {
    // mock: true,
    control: 'upload/cms/column/shoppingExcellentShop/index.html'
  },
  // 店铺首页U谷优商
  cms_shopExcellentShop: {
    // mock: true,
    control: 'upload/cms/column/shopExcellentShop/index.html'
  },
  // 查询员工个采banner
  cms_staffWelfareBanner: {
    // mock: true,
    control: 'upload/cms/column/staff_welfare_banner/index.html'
  },
  // 查询员工个采爆款
  cms_hotCommodity: {
    // mock: true,
    control: 'upload/cms/column/hot_commodity/index.html'
  },
  // 查询员工个采背景颜色
  cms_staffWelfareBgColor: {
    // mock: true,
    control: 'upload/cms/column/bgColor/index.html'
  },
  // 集采专区轮播图
  cms_jcLunbo: {
    // mock: true,
    control: 'upload/cms/column/jclunbo/index.html'
  },
  // 核电专区轮播图
  cms_hdlunbo: {
    // mock: true,
    control: 'upload/cms/column/hdlunbo/index.html'
  },
  // 扶贫专区轮播图
  cms_fpLunbo: {
    // mock: true,
    control: 'upload/cms/column/fplunbo/index.html'
  },
  // 查询新闻
  cms_cnncNews: {
    // mock: true,
    control: 'upload/cms/column/news/index.html'
  },
  // 查询公告
  cms_cnncNotice: {
    // mock: true,
    control: 'upload/cms/column/notice/index.html'
  },
  // 查询第三方供应商
  cms_cnncSupplier: {
    // mock: true,
    control: 'upload/cms/column/eCommendBrand/index.html'
  },
  // 查询个人防护
  cms_personalProtection: {
    // mock: true,
    control: 'upload/cms/column/personalProtection/index.html'
  },
  // 查询工具耗材
  cms_toolConsumables: {
    // mock: true,
    control: 'upload/cms/column/toolConsumables/index.html'
  },
  // 查询金属加工
  cms_metalWorking: {
    // mock: true,
    control: 'upload/cms/column/metalWorking/index.html'
  },
  // 查询清洁办公
  cms_cleanOffice: {
    // mock: true,
    control: 'upload/cms/column/cleanOffice/index.html'
  },
  // 查询仪表仪器
  cms_instrumentation: {
    // mock: true,
    control: 'upload/cms/column/instrumentation/index.html'
  },
  // 查询电器照明
  cms_lighting: {
    // mock: true,
    control: 'upload/cms/column/lighting/index.html'
  },
  // 查询流转传动
  cms_drive: {
    // mock: true,
    control: 'upload/cms/column/drive/index.html'
  },
  // 查询防护安全
  cms_protectiveSafety: {
    // mock: true,
    control: 'upload/cms/column/protectiveSafety/index.html'
  },
  // 查询场景化采购
  cms_scenarioBasedProcurement: {
    // mock: true,
    control: 'upload/cms/column/scenarioBasedProcurement/index.html'
  },
  // 查询帮助中心
  cms_helpCenter: {
    // mock: true,
    control: 'upload/cms/column/helpCenter/index.html'
  },
  // 首页核级设备查询
  cms_syhjsb: {
    // mock: true,
    control: 'upload/cms/column/syhjsb/index.html'
  },
  // 首页非核级设备查询
  cms_syfhjsb: {
    // mock: true,
    control: 'upload/cms/column/syfhjsb/index.html'
  },
  // 直销店铺
  cms_BrandArea: {
    // mock: true,
    control: 'upload/cms/column/brandArea/index.html'
  },
  // 查询电子超市品牌logo
  cms_shopBrandArea: {
    // mock: true,
    control: 'upload/cms/column/shopBrandArea/index.html'
  },
  // 查询产品分类图片
  cms_productClassification: {
    // mock: true,
    control: 'upload/cms/column/productClassification/index.html'
  },
  // 查询自营品牌logo
  cms_speciBrandArea: {
    // mock: true,
    control: 'upload/cms/column/speciBrandArea/index.html'
  },
  // 帮助中心菜单
  cms_bzzxzclb: {
    // mock: true,
    control: 'upload/cms/column/bzzxzclb/index.html'
  },
  // 商品搜索
  m_searchHotSaleGoods: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/searchHotSaleGoods'
  },
  // 商品库存查询
  m_queryGoodsStock: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryGoodsStock'
  },
  // 频道查询
  m_selectChannel: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryChannel'
  },
  // 类目查询
  m_qryAllLevel: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryGoodsCategory'
  },
  // 零级类目查询
  m_queryGoodsZeroCategory: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryGoodsZeroCategory'
  },
  // 集采专区-MRO
  cms_jcmro: {
    // mock: true,
    control: 'upload/cms/column/jcmro/index.html'
  },
  // 集采专区-MRO二级类目
  cms_twojc: {
    // mock: true,
    control: 'upload/cms/column/twojc/index.html'
  },
  // 集采专区-办公用品
  cms_jcbgyp: {
    // mock: true,
    control: 'upload/cms/column/jcbgyp/index.html'
  },
  // 集采专区-办公用品二级类目
  cms_twobgyp: {
    // mock: true,
    control: 'upload/cms/column/twobgyp/index.html'
  },
  // 集采专区-大宗通用
  cms_jcdzty: {
    // mock: true,
    control: 'upload/cms/column/jcdzty/index.html'
  },
  // 集采专区-大宗通用二级类目
  cms_twodzty: {
    // mock: true,
    control: 'upload/cms/column/twodzty/index.html'
  },
  // 查询扶贫专区楼层
  cms_cnncFupin: {
    // mock: true,
    control: 'upload/cms/column/fupin/index.html'
  },
  // 查询扶贫专区楼层
  cms_recommend: {
    // mock: true,
    control: 'upload/cms/column/recommend/index.html'
  },
  // 商品管理-商品池管理-商品池管理-商品分页-根据频道查询标签
  ucc_queryChannelLable: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/queryChannelLable'
  },
  // 采购电商商城热词入库API
  m_addSearchHotWord: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/addSearchHotWord'
  },
  // 活动商品类型查询API
  m_qryActivityGoodsClassification: {
    // mock: true,
    control: 'dyc/mall/commodity/qryActivityGoodsClassification'
  },
  // 搜索历史记录列表查询
  m_qrySearchHistoryList: {
    // mock: true,
    control: 'dyc/mall/commodity/qrySearchHistoryList'
  },
  // 搜索黑名单查询
  m_qrySearchWordBlack: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/qrySearchWordBlack'
  },
  // 采购电商商城电子超市商品搜索框支持自动补全或者纠错API
  m_suggestAutomatic: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/suggestAutomatic'
  },
  // 联想词搜索
  m_qryAssociateWords: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/qryAssociateWords'
  },
  // 采购电商商城电子超市商品搜索框支持自动补全或者纠错API
  m_statisticSearchKeywords: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/statisticSearchKeywords'
  },
  // 搜索历史记录列表新增
  m_addSearchHistory: {
    // mock: true,
    control: 'dyc/mall/commodity/addSearchHistory'
  },
  // 搜索历史记录删除服务
  m_deleteSearchHistoryList: {
    // mock: true,
    control: 'dyc/mall/commodity/deleteSearchHistoryList'
  },
  // 搜索历史记录全部删除
  m_deleteAllSearchHistoryList: {
    // mock: true,
    control: 'dyc/mall/commodity/deleteAllSearchHistoryList'
  },
  // 采购电商商城电子超市价格实时查询API
  m_queryCurrentPrice: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryCurrentPrice'
  },
  // 采购电商商城商品详情查询能力服务
  m_PesappMallDetailQryAbilityService: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/qryCommdDetails'
  },
  // 查询商品轮播图片
  m_qryShufflingPic: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/qryShufflingPic'
  },
  // 商品管理-商品池管理-商品池管理-商品详情-查询标签
  ucc_queryGoodsDetailsShowLabel: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryGoodsDetailsShowLabel'
  },
  // 商品三级类目详请查询
  m_queryGoodsThreeCatalog: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/getCnncMallCommdDetailGuiCatelog'
  },
  // 详情查询
  m_querySupplierShopDetail: {
    // mock: true,
    control: 'cnnc/estore/noauth/querySupplierShopDetail'
  },
  // 供应商查询店铺详情
  pes_querySupplierShopDetail: {
    // mock: true,
    control: 'cnnc/estore/querySupplierShopDetail'
  },
  // 购物车频道列表数量查询API
  m_qrySourceCountList: {
    // mock: true,
    control: 'dyc/mall/shopcart/queryShoppingCartNum'
  },
  // 详情查询
  m_qryCommdDetails: {
    // mock: true,
    control: 'dyc/saas/common/mall/noauth/queryGoodsDetail'
  },
  // 查询比价
  m_compareGoodsPrice: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/compareGoodsPrice'
  },
  // 京东商品预计送达时间
  m_getCnncExpectDeliveryTime: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/getCnncExpectDeliveryTime'
  },
  // 取消收藏
  m_cancelGoodsCollect: {
    // mock: true,
    control: 'dyc/saas/common/user/removeGoodsCollections'
  },
  // 加入收藏
  m_addGoodsCollect: {
    // mock: true,
    control: 'dyc/saas/common/user/addGoodsCollections'
  },
  // 申请上架商品清单模板生成API
  m_getApplyForSaleTemplate: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getApplyForSaleTemplate'
  },
  // 查询收藏
  m_queryCollectGoods: {
    // mock: true,
    control: 'dyc/saas/common/user/getGoodsCollectionsPageList'
  },
  // 查询评价统计数据
  uec_qryEvalStatistics: {
    // mock: true,
    control: 'dyc/mall/evaluate/users/signup/dataStatistics'
  },
  // 查询评价列表
  mall_qryEvaluateList: {
    // mock: true,
    control: 'dyc/mall/evaluate/users/qryEvaluateList'
  },
  // 查询评价列表 不登录调用
  mall_qrySignupEvaluateList: {
    // mock: true,
    control: 'dyc/mall/evaluate/users/signup/qryEvaluateList'
  },
  // 评价点赞取消
  uec_dealEvaluateLikeCancel: {
    // mock: true,
    control: 'dyc/mall/evaluate/service/routing/dealEvaluateLikeCancel'
  },
  // 评价点赞
  uec_dealEvaluateLike: {
    // mock: true,
    control: 'dyc/mall/evaluate/service/routing/dealEvaluateLike'
  },
  // 查询回复列表
  uec_qryReplyList: {
    // mock: true,
    control: 'dyc/mall/evaluate/users/signup/qryReplyList'
  },
  // 评论回复创建
  uec_createReplyInfo: {
    // mock: true,
    control: 'dyc/mall/evaluate/service/routing/createReplyInfo'
  },
  // 协议下商品查询
  m_queryAgreementGoods: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryAgreementGoods'
  },
  // 无协议商品详情
  ucc_noauthQueryGoodsDetails: {
    // mock: true,
    control: 'dyc/saas/common/mall/noauth/qryInfoDetail'
  },
  // 发票邮寄地址--账套
  m_queryProcureDept: {
    // mock: true,
    control: 'dyc/saas/common/getEnterpriseAccountPage'
  },
  // 会员收货地址查询
  m_queryReceiveAddress: {
    // mock: true,
    control: 'dyc/saas/common/getLogisticsRelaPage'
  },
  // 会员收货地址新增
  m_addReceiveAddress: {
    // mock: true,
    control: 'dyc/saas/common/user/addLogisticsRela'
  },
  // 会员收货地址智能识别
  m_getExtractExpress: {
    // mock: true,
    control: 'dyc/saas/common/user/getExtractExpress'
  },
  // 会员收货地址删除
  m_deleteReceiveAddress: {
    // mock: true,
    control: 'dyc/common/user/deleteReceiveAddress'
  },
  // 会员收货地址修改
  m_updateReceiveAddress: {
    // mock: true,
    control: 'dyc/saas/common/user/updateLogisticsRela'
  },
  // 会员收货地址设置默认
  m_setDefaultAddress: {
    // mock: true,
    control: 'dyc/mall/user/setDefaultAddress'
  },
  // 设置邮寄地址默认
  m_setMainInvoiceAddress: {
    // mock: true,
    control: 'dyc/saas/common/user/setMainInvoiceAddress'
  },
  // 文件上传
  m_fileGenerationUpload: {
    // mock: true,
    control: 'dyc/common/communal/fileGeneration/upload'
  },
  // 商品导入
  m_importGoods: {
    // mock: true,
    control: 'dyc/saas/common/user/importGoods'
  },
  // 无协议商品店铺详情
  dyc_getSkuBelongChanel: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/getSkuBelongChanel'
  },
  // 查询站内信
  notice_QryMessage: {
    // mock: true,
    control: 'dyc/common/communal/gemini/qryInnerMessage'
  },
  // 查询站内信详情
  notice_QryMessageDetail: {
    control: 'dyc/common/communal/gemini/qryInnerMessageDetails'
  },
  // 查询站内信
  message_selectMessage: {
    // mock: true,
    control: 'dyc/common/communal/gemini/qryInnerMessage'
  },
  // 查询未读消息数
  notice_NoReadMessage: {
    // mock: true,
    control: 'dyc/common/user/message/selectNoReadMessage'
  },
  // 查询消息详情
  notice_GetMessageText: {
    // mock: true,
    control: 'common/author/message/getMessageText'
  },
  // 消息设为已读
  notice_HaveRead: {
    // mock: true,
    control: 'common/author/message/haveRead'
  },
  // 消息全部设为已读
  notice_AllHaveRead: {
    // mock: true,
    control: 'dyc/common/user/message/allHaveRead'
  },
  // 删除消息
  notice_DeleteByMessageId: {
    // mock: true,
    control: 'dyc/common/communal/gemini/editInnerMessageStatus'
  },
  // 商品详情页的接口
  dyc_dealItemSpecInfo: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/dealItemSpecInfo'
  },
  // XXX
  dyc_queryMerchantConfig: {
    // mock: true,
    control: 'dyc/fsc/queryMerchantConfig'
  },
  // 购物车的接口
  dyc_deaMallHotpurchasedList: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/deaMallHotpurchasedList'
  },
  // 购物车的接口
  cnnc_checkSupConf: {
    // mock: true,
    control: 'dyc/saas/self/order/checkSupConf'
  },
  // 批量查询是否收藏
  common_getGoodsCollectionList: {
    // mock: true,
    control: 'dyc/saas/common/user/getGoodsCollectionsPageList'
  },
  // 商城频道热词查询API
  dyc_getDycUccMallChannelhotwordsQry: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/getDycUccMallChannelhotwordsQry'
  },
  // 企业个人/企业注册
  common_registerAccount: {
    // mock: true，
    // control: 'dyc/common/user/noauth/personUserRegister',
    control: '/dyc/saas/common/user/noauth/registerAccount'
  },
  // 企业认证
  common_savePersonalAuth: {
    // mock: true，
    // control: 'dyc/common/user/noauth/personUserRegister',
    control: 'dyc/saas/common/user/savePersonalAuth'
  },
  // 企业用户注册
  common_enterpriseUserRegister: {
    // mock: true，
    control: 'dyc/common/user/noauth/enterpriseUserRegister'
  },
  // 供应商校验用户名手机号邮箱
  pes_addCheckUserExist: {
    // mock: true，
    control: 'dyc/common/user/noauth/addCheckUserExist'
  },
  // 用户信息校验账号或手机号或证件号
  pes_checkUserInfo: {
    // mock: true，
    control: '/dyc/saas/common/user/noauth/checkUserInfo'
  },
  // 商家合作入驻校验公司名称是否已经填写
  pes_checkBusinessCooperSettleInfo: {
    // mock: true，
    control: 'dyc/saas/common/noauth/checkBusinessCooperSettleInfo'
  },
  // 机构是否存在校验服务不登录
  umc_noauth_checkEnterpriseOrgIsExist: {
    // mock: true，
    control: 'dyc/common/user/noauth/org/checkEnterpriseOrgIsExist'
  },
  // 机构名称或统一信用代码或机构编码或机构简称
  umc_noauth_checkEnterpriseInfo: {
    // mock: true，
    control: '/dyc/saas/common/user/noauth/checkEnterpriseInfo'
  },
  // 供应商短信校验码
  pes_verificationMeseageCode: {
    // mock: true，
    control: 'dyc/supplier/suppliermgnt/noauth/supplier/supplierregister/verificationMeseageCode'
  },
  // 注册身份证唯一校验
  common_addCheckUserExist: {
    // mock: true，
    control: 'dyc/common/user/noauth/addCheckUserExist'
  },
  // 查询购物车列表API
  umc_qryShoppingCartList: {
    // mock: true,
    control: 'dyc/saas/common/usc/getShoppingCartPageNewList'
  },
  // 查询购物车信息
  umc_qryUccBatchShoppingCartList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryUccBatchShoppingCartList'
  },
  // 查询门槛运费
  umc_qryFreightConfigListByOrgIds: {
    // mock: true,
    control: 'dyc/saas/common/freight/qryFreightConfigListByOrgIds'
  },
  // 删除购物车API服务
  usc_deleteShoppingCartGoods: {
    // mock: true,
    control: 'dyc/saas/common/user/removeShoppingCart'
  },
  // 购物车选择/取消API
  usc_tickOrCancelShoppingCartGoods: {
    // mock: true,
    control: 'dyc/saas/common/user/tickOrCancelShoppingCartGoods'
  },
  // 购物车选择/取消API
  usc_updateSkuPlanNo: {
    // mock: true,
    control: 'dyc/mall/shopcart/updateSkuPlanNo'
  },
  // 购物车商品导入模版下载服务API
  usc_downloadGoodsImportTemplate: {
    // mock: true,
    control: 'dyc/saas/common/usc/downloadGoodsImportTemplate'
  },
  // 购物车商品导出服务API
  usc_exportGoods: {
    // mock: true,
    control: 'dyc/saas/common/usc/exportShoppingCartGoods'
  },
  // 购物车商品导入服务API
  usc_importGoods: {
    // mock: true,
    control: 'dyc/mall/shopcart/importShoppingCartGoods'
  },
  // 购物车明细数量更新API
  usc_changeShoppingCartGoodsAmount: {
    // mock: true,
    control: 'dyc/saas/common/user/changeShoppingCartGoodsAmount'
  },
  // 购物车频道列表数量查询API
  common_queryShoppingCartAmount: {
    // mock: true,
    control: 'dyc/saas/common/user/queryShoppingCartAmount'
  },
  // 部门预算余额查询
  mall_queryDeptBudgetBalance: {
    // mock: true,
    control: 'dyc/mall/user//queryDeptBudgetBalance'
  },
  // 购物车商品概要信息查询
  mall_queryShoppingCartGoodsBaseInfo: {
    // mock: true,
    control: 'dyc/saas/common/user/queryShoppingCartGoodsBaseInfo'
  },
  // 物料列表查询
  mall_queryMaterialsList: {
    // mock: true,
    control: 'dyc/mall/commodity/queryMaterialsList'
  },
  // 物料选择
  mall_chooseMaterials: {
    // mock: true,
    control: 'dyc/mall/commodity/chooseMaterials'
  },
  // 物料选择
  mall_queryDeliveryTimeRange: {
    // mock: true,
    control: 'cnnc/mall/queryDeliveryTimeRange'
  },
  // 比价商品列表查询
  mall_queryParityGoodsList: {
    // mock: true,
    control: 'dyc/mall/commodity/queryParityGoodsList'
  },
  // 商品购物车id查询
  mall_qryGoodUscInfo: {
    // mock: true,
    control: 'dyc/saas/common/usc/qryGoodUscInfo'
  },
  // 比选详情查询
  mall_queryComparisonSelectionDetails: {
    // mock: true,
    control: 'dyc/self/order/qryCmpOrderDetail'
  },
  // 比选详情导出
  mall_exportComparisonSelectionDetails: {
    // mock: true,
    control: 'cnnc/mall/exportComparisonSelectionDetails'
  },
  // 比价商品列表查询
  mall_queryNotChooseCompareGoods: {
    // mock: true,
    control: 'dyc/mall/commodity/queryNotChooseCompareGoods'
  },
  // 生成比选单
  mall_createCompareOrder: {
    // mock: true,
    control: 'dyc/self/order/createCmpOrder'
  },
  // 京东订单交易模式查询
  m_qryOrderSettlement: {
    // mock: true,
    control: 'dyc/busicommon/order/qryOrderSettlement'
  },
  // 京东pin信息
  m_qryOrgBaseInfo: {
    // mock: true,
    control: '/dyc/common/user/org/qryOrgBaseInfo'
  },
  // 查询商品频道
  mall_queryChannel: {
    // mock: true,
    control: '/dyc/mall/commodity/noauth/queryChannel'
  },
  // 我的采购计划列表查询
  dyc_qryPpcPurchasePlanItemList: {
    // mock: true,
    control: 'dyc/saas/common/plan/qryPpcPurchasePlanItemList'
  },
  // 商品实时运费查询
  peb_queryGoodsFreight: {
    // mock: true,
    control: 'dyc/mall/commodity/queryGoodsFreight'
  },
  // 冗余物资付款渠道查询
  fsc_qryPayConfigDetailOrPayConfig: {
    // mock: true,
    control: 'cnnc/estore/fsc/qryPayConfigDetailOrPayConfig'
  },
  // 合并下单
  cnnc_mergeCreateOrder: {
    // mock: true,
    control: 'dyc/mall/order/mergeCreateOrder'
  },
  // 合并订单结果查询
  peb_qryOrderResult: {
    // mock: true,
    control: 'dyc/mall/order/qryOrderResult'
  },
  // 立即支付
  cnnc_dealPay: {
    // mock: true,
    control: 'dyc/mall/order/dealPay'
  },
  common_applyForSaleAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/applyForSaleAdd'
  },
  // 查询频道广场
  cms_channelplaza: {
    // mock: true,
    control: 'upload/cms/column/channelplaza/index.html'
  },
  // 查询热门推荐
  cms_popularRecommend: {
    // mock: true,
    control: 'upload/cms/column/EditerRecommend/index.html'
  },
  // 新品上架
  cms_newCommodityPublic: {
    // mock: true,
    control: 'upload/cms/column/nwe_comodity_public/index.html'
  },
  // 查询商品分类
  cms_categories: {
    // mock: true,
    control: 'upload/cms/column/categories/index.html'
  },
  // 查询优选品牌
  cms_preferredBrand: {
    // mock: true,
    control: 'upload/cms/column/preferredBrand/index.html'
  },
  // 查询新店铺是否装修
  cms_whetherHave: {
    // mock: true,
    control: 'dncp-admin/dncp/canvas/whetherHave'
  },
  // 购物车下单检测供应商是否开通商户
  dyc_checkSupplierMerchant: {
    // mock: true,
    control: 'dyc/fsc/checkSupplierMerchant'
  },
  // 登录获取审批情况
  dyc_queryRegisterStatusorgIdWeb: {
    // mock: true,
    control: 'dyc/saas/common/queryRegisterStatus'
  },
  // 店铺推广列表查询
  dyc_qryShopHomeExtensionList: {
    // mock: true,
    control: 'dyc/mall/store/noauth/qryShopHomeExtensionList'
  },
  // 店铺推广 - 商品类型查询
  dyc_queryDropCommdType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryDropCommdType'
  },
  // 店铺推广 - 商品类型查询免登录
  dyc_noauth_queryDropCommdType: {
    // mock: true,
    control: 'dyc/mall/store/noauth/qryShopHomeExtensionList'
  },
  // 详情详情，供应商、店铺查询
  commodityc_qryVendorAndSupplier: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/qryVendorAndSupplier'
  },
  // 历史成交价
  shopMall_getPriceRecord: {
    // mock: true,
    // control: 'dyc/busicommon/order/getPriceRecord'
    control: 'dyc/busicommon/commodity/noauth/getPriceRecord'
  },
  // 店铺首页类目查询
  shopMall_getCategoryQryShop: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/getCategoryQryShop'
  },
  // 同款商品
  shopMall_qrySimilarSkuList: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/qrySimilarSkuList'
  },
  // POC下单
  shopMall_createOrder: {
    // mock: true,
    control: 'dyc/saas/self/order/createOrder'
  },
  // 首页计数商品数量查询
  shopMall_getCommodityNum: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/getCommodityNum'
  },
  // 【POC下单】按钮显示控制（uat环境不显示）
  shopMall_qryPoc: {
    // mock: true,
    control: 'dyc/mall/order/qryPoc'
  },
  // POC查询结果
  shopMall_qryOrderCreateResult: {
    // mock: true,
    control: 'dyc/saas/self/order/qryOrderCreateResult'
  },
  // 查询待办数量
  queryToDoCount: {
    // mock: true,
    control: 'dyc/saas/common/user/queryToDoCount'
  },
  // 查询待办列表
  queryToDoList: {
    // mock: true,
    control: 'dyc/saas/common/user/queryToDoList'
  },
  // 查询已办列表
  queryHaveDoneList: {
    // mock: true,
    control: 'dyc/saas/common/user/queryHaveDoneList'
  },
  // 代办项列表查询API
  queryToDoItemList: {
    control: 'dyc/saas/common/user/queryToDoItemList'
  },
  // 注册行业数据字典
  queryData: {
    control: 'dyc/saas/common/user/noauth/queryData'
  },
  // 注册驳回数据
  qryRegistDetail: {
    control: 'dyc/saas/common/user/qryRegistDetail'
  },
  // 注册园区信息列表
  rest_getParkInfoList: {
    control: 'dyc/saas/common/park/noauth/getParkInfoList'
  },
  // 注册回填信息
  rest_registReFillAccount: {
    // mock: true,
    control: '/dyc/saas/common/user/registReFillAccount'
  },
  // 商家合作入驻
  rest_createBusinessCooperSettleInfo: {
    // mock: true,
    control: 'dyc/saas/common/noauth//createBusinessCooperSettleInfo'
  },
  // 从商品详情拿列表
  shopMall_directOrderCommonQry: {
    // mock: true,
    control: 'dyc/common/shopcart/directOrderCommonQry'
  },
  // 选中多件商品立即下单拿列表
  shopMall_batchDirectOrderCommonQry: {
    // mock: true,
    control: 'dyc/common/shopcart/batchDirectOrderCommonQry'
  },
  // 从合同下单详情拿列表
  shopMall_qryUccBatchShoppingCartByCostList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryUccBatchShoppingCartByCostList'
  },
  // 单点登录
  shopMall_ext: {
    // mock: true,
    control: 'umc/noauth/login/ext'
  },
  // 中转获取地址
  shopMall_getCasLoginUrl: {
    // mock: true,
    control: 'umc/noauth/login/getCasLoginUrl'
  },
  // 查询联东项目同步过来的法人信息
  shopMall_selectLegalEntityInformation: {
    // mock: true,
    control: 'dyc/common/user/selectLegalEntityInformation'
  },
  // 查询联东项目下拉树
  shopMall_selectProjectInfoList: {
    // mock: true,
    control: 'dyc/common/user/selectProjectInfoList'
  },
  // 查询联东项目同步过来的法人信息
  shopMall_selectLegalEntityInfo: {
    // mock: true,
    control: '/dyc/saas/common/user/selectLegalEntityInfo'
  },
  // 查询联东项目下拉树
  shopMall_saasSelectProjectInfoList: {
    // mock: true,
    control: '/dyc/saas/common/user/selectProjectInfoList'
  },
  // 查询联东机构详情
  shopMall_qryLdOrgInfoDetail: {
    // mock: true,
    control: '/dyc/saas/common/user/qryLdOrgInfoDetail'
  },
  // 查询外部发票信息
  shopMall_qryInvoiceListPage: {
    // mock: true,
    control: '/dyc/saas/common/user/qryInvoiceListPage'
  },
  // 复制收货地址到发票邮寄地址
  shopMall_createInvoiceAddressByLogisticsRela: {
    // mock: true,
    control: 'dyc/saas/common/createInvoiceAddressByLogisticsRela'
  },
  // 查询本月预算
  shopMall_getPurchaseLimitDetail: {
    control: '/dyc/saas/common/user/getPurchaseLimitDetail'
  },
  // 获取注册验证码
  umc_signup_getPcRegistMobileVfCode: {
    // mock: true，
    control: '/umc/users/signup/getPcRegistMobileVfCode'
  },
  // 校验注册码
  umc_codeCheckRegister: {
    // mock: true，
    control: 'dyc/saas/common/user/noauth/codeCheckRegister'
  }
}, _defineProperty(_getLogin$cnnc_getPcL, "qryRegistDetail", {
  control: 'dyc/saas/common/user/qryRegistDetail'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_qryManagerUserInfoList", {
  control: 'dyc/saas/common/user/qryManagerUserInfoList'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_getEntid", {
  control: 'dyc/saas/common/user/noauth/getEntid'
}), _defineProperty(_getLogin$cnnc_getPcL, "common_noauthUpload", {
  control: 'dyc/common/communal/noauth/fileGeneration/upload'
}), _defineProperty(_getLogin$cnnc_getPcL, "busicommon_getWmsSupplierIds", {
  control: 'dyc/busicommon/commodity/noauth/getWmsSupplierIds'
}), _defineProperty(_getLogin$cnnc_getPcL, "busicommon_qryWmsStock", {
  control: 'dyc/busicommon/commodity/noauth/qryWmsStock'
}), _defineProperty(_getLogin$cnnc_getPcL, "saas_queryAvailableWareHouse", {
  control: 'dyc/saas/supplier/queryAvailableWareHouse'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_match", {
  control: 'dyc/mall/commodity/inquirySheet/match'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_noauthMatch", {
  control: 'dyc/mall/commodity/inquirySheet/noauth/match'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_qryImportTemplateDetai", {
  control: 'dyc/config/cfc/unite/qryImportTemplateDetail'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_qryNoauthImportTemplateDetai", {
  control: 'dyc/config/cfc/unite/noauth/qryImportTemplateDetail'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_batchImportByFile", {
  control: 'dyc/mall/commodity/inquiry/batchImportByFile'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_noauthBatchImportByFile", {
  control: 'dyc/mall/commodity/noauth/inquiry/batchImportByFile'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_searchGoodProperty", {
  control: 'dyc/mall/commodity/inquiry/searchGoodProperty'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_noauthSearchGoodProperty", {
  control: 'dyc/mall/commodity/noauth/inquiry/searchGoodProperty'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_inquirySearchGoods", {
  control: 'dyc/mall/commodity/inquirySearchGoods'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_noauthInquirySearchGoods", {
  control: 'dyc/mall/commodity/noauth/inquirySearchGoods'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_searchTempGoodProperty", {
  control: 'dyc/mall/commodity/inquiry/searchTempGoodProperty'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_inquirySearchTempGoods", {
  control: 'dyc/mall/commodity/inquirySearchTempGoods'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_inquiryCreate", {
  control: 'dyc/mall/commodity/inquirySheet/create'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_myDetailList", {
  control: 'dyc/mall/commodity/myDetailList'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_noauthInquiryCreate", {
  control: 'dyc/mall/commodity/inquirySheet/noauth/create'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_myInquirySheetList", {
  control: 'dyc/mall/commodity/myInquirySheetList'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_myInquirySheetDetail", {
  control: 'dyc/mall/commodity/myInquirySheetDetail'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_getCanvasInfo", {
  control: 'dyc/dncp-admin/dncp/canvas/getCanvasInfo'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_filterBrand", {
  control: 'dyc/mall/commodity/noauth/filterBrand'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_qryBrandDetail", {
  control: 'dyc/busicommon/commodity/noauth/qryBrandDetail'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_poolIdConfig", {
  control: 'dyc/busicommon/commodity/noauth/poolIdConfig'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_setDefaultEnterpriseInvoce", {
  control: 'dyc/saas/common/user/setDefaultEnterpriseInvoce'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_operAccountInvoice", {
  control: 'dyc/saas/common/user/operAccountInvoice'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_qeryOrderNumberAccount", {
  control: 'dyc/saas/mall/order/qeryOrderNumberAccount'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_dealSubmitLimitBpm", {
  control: 'dyc/saas/self/order/dealSubmitLimitBpm'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_qryEnterpriseInfoDetail", {
  control: 'dyc/saas/mall/order/qryEnterpriseInfoDetail'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_qryOwnerIdByInvoiceTile", {
  control: 'dyc/saas/common/user/qryOwnerIdByInvoiceTile'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_cartPreferentialPrice", {
  control: 'dyc/common/shopcart/cartPreferentialPrice'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_batchDirectOrderCommonQry", {
  control: 'dyc/common/shopcart/batchDirectOrderCommonQry'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_checkVisibility", {
  // mock: true,
  // control: 'dyc/saas/common/mall/noauth/checkVisibility'
  control: 'dyc/saas/common/mall/checkVisibility'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_queryGoodsStock", {
  control: 'dyc/mall/commodity/noauth/queryGoodsStock'
}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_qryIsInnerOrderMandatoryField", {
  // mock: true,
  control: 'dyc/saas/self/order/qryIsInnerOrderMandatoryField' // control: 'dyc/saas/common/mall/noauth/checkVisibility'

}), _defineProperty(_getLogin$cnnc_getPcL, "shopMall_checkAutomaticQuotation", {
  // mock: true,
  control: 'dyc/mall/commodity/os/quickinquiry/checkAutomaticQuotation'
}), _getLogin$cnnc_getPcL);